import { Box, Text } from '@chakra-ui/react';
import AuthService from 'api/services/AuthService';
import InputMy from 'components/InputMy';
import AuthButton from 'components/singIn/AuthButton';
import BackButton from 'components/singIn/BackButton';
import SecondState from 'components/singIn/SecondState';
import Subtitle from 'components/singIn/Subtitle';
import Title from 'components/singIn/Title';
import { useFormik } from 'formik';
import useRedirectURL from 'hooks/useRedirectURL';
import DefaultAuth from 'layouts/auth/Default';
import { useState } from 'react';
import { ROUTES } from 'routes';
import { emailValidationSchema } from 'validations';

const Second = ({ email }: { email: string }) => {
    return (
        <SecondState
            title="Reset your password"
            email={email}
            subtitle={
                <>
                    We've sent an email to{' '}
                    <Text as="span" color="gray.900">
                        {email}
                    </Text>
                    . Follow its instructions to reset your password. If you don't see the email after a minute, please
                    check your spam folder.
                </>
            }
        />
    );
};

function PasswordRecovery() {
    const [loading, setLoading] = useState(false);
    const url = useRedirectURL(ROUTES.reset_password.fullPath);
    const [value, setValue] = useState(1);
    const formik = useFormik({
        initialValues: { email: '' },
        validationSchema: emailValidationSchema,
        onSubmit: async params => {
            console.log(params);
            try {
                setLoading(true);
                await AuthService.resetSend({ ...params, url })
                    .then(response => {
                        console.log('response', response);
                        setValue(2);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } catch (e) {
                return false;
            }
        },
    });

    return (
        <DefaultAuth>
            {value === 1 ? (
                <Box>
                    <BackButton href="/auth/sign-in">Back to Sign In</BackButton>
                    <Title>Reset your password</Title>
                    <Subtitle>Enter the email you use to sign in to Lead Pulse to reset your password</Subtitle>
                    <InputMy
                        name="email"
                        label="Email"
                        required
                        disabled={loading}
                        type="email"
                        placeholder="example@mail.com"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                        onBlur={formik.handleBlur}
                        sx={{ marginBottom: '24px' }}
                    />
                    <AuthButton onClick={formik.submitForm} loading={loading}>
                        Reset password
                    </AuthButton>
                </Box>
            ) : (
                <Second email={formik.values.email} />
            )}
        </DefaultAuth>
    );
}

export default PasswordRecovery;
